<template>
  <div class="flex flex-col pb-4">
    <div
      class="py-4 px-4 md:px-6 bg-utility-gray-50 border-b border-utility-gray-200"
    >
      <Select
        v-if="languages.length"
        v-model="selectedLocale"
        :options="languages"
      >
        <template #icon>
          <Icon name="globe" size="xl" class="text-utility-gray-500" />
        </template>
      </Select>
    </div>
    <div class="flex-col gap-4 divide-y divide-utility-gray-200">
      <Message
        v-for="message in screens"
        :key="message.id"
        :message="message"
        :locale="selectedLocale"
        :tenant="tenant"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { Select } from "@/Components/Select";
import { first } from "lodash";
import { Icon } from "@/SharedComponents/Icon";
import { Message } from "@/Pages/Settings/MessengerFlow/Partials";

const { t } = useI18n();

const props = defineProps({
  tenant: { type: Object, required: true },
  screens: { type: Array, required: true },
  allowedLocales: { type: Array, required: true },
});

const languages = computed(() => {
  return props.allowedLocales.map((locale) => {
    return {
      value: locale,
      label: t(`validation.values.locale.${locale}`),
    };
  });
});

const selectedLocale = ref(first(props.allowedLocales));
</script>
